export default __webpack_public_path__ + "static/media/3.0a251ea2.svg";